// extracted by mini-css-extract-plugin
export default {"meals":"VeggiesDB_meals__DtwnG","meals-appear":"VeggiesDB_meals-appear__2iyPT"};